import { useState } from "react";
import { useRecoilValue } from "recoil";

import { useTranslation } from "src/hooks/translation";
import selectionsStore from "src/stores/selections";
import NumericInput from "src/common/components/numericInput";
import { decimalString } from "src/constants/types";
import { emitFindBetByBookId } from "src/services/communicator/actions";
import BookingCheckImage from "src/assets/images/booking_check.png";
import LeftSnow from "src/assets/images/left-snow.svg";
import RightSnow from "src/assets/images/right-snow.svg";
import { useConfig } from "src/hooks/config";

import "./style.scss";

interface IProps {
	isMobile?: boolean;
}

const BookingCheckBlock = ({ isMobile }: IProps) => {
	const t = useTranslation();
	const { selections } = useRecoilValue(selectionsStore);
	const config = useConfig();
	const [bookId, setBookId] = useState<decimalString>("");

	const findBet = () => {
		if (bookId) {
			emitFindBetByBookId(+bookId)
			setBookId("")
		}
	};

	if (selections.length) return null;

	return (
		<div className="B-betslip-booking-check-block">
			{config.enableWinterMode && <><img src={LeftSnow} alt="left snow" className="left-snow" /> <img src={RightSnow} alt="right snow" className="right-snow" /></>}

			<div className="B-check-block-heading">
				<img src={BookingCheckImage} alt="booking check" />
				<p>
					{t("Quick access to your")} <span className="B-font-bold">{t("BOOKINGS")}</span>{" "}
					<br />
					{t("Just enter the")} <span className="B-font-bold">{t("ID")}</span>
				</p>
			</div>
			<NumericInput
				value={bookId}
				maxLength={20}
				onChange={setBookId}
				isMobile={isMobile}
				placeholder="Booking ID"
				className="B-check-input"
			/>

			<button className="B-find-btn" onClick={findBet}>
				{t("FIND")}
			</button>
		</div>
	);
};

export default BookingCheckBlock;
